import RuleSave from "@/pages/custom-components/RuleComponents/RuleActionParameter/RuleSave";
import RuleRender from "@/pages/custom-components/RuleComponents/RuleActionParameter/RuleRender";
import React from "react";

type ActionKey = "CREATE_LOGIC_CLIP" | "CREATE_MATERIALIZE_LOGIC_CLIP" | "MATERIALIZE_LOGIC_CLIP";

type ConditionType = "multistring" | "int" | "date";

export interface Condition {
    source: string;
    options: string[];
    type: ConditionType;
}

interface Trigger {
    actions: TRIGGER_ACTION[];
    conditions: string[];
}

interface Categories {
    time: string[];
    match: string[];
    calendar: string[];
    platform: string[];
}

export enum ruleCategoriesEnum {
    TIME = 'time',
    MATCH = 'match',
    PLATFORM = 'platform',
    CALENDAR = 'calendar'
}

interface Actions {
    [key: string]: string[];
}

interface Triggers {
    [key: string]: Trigger;
}

interface Conditions {
    [key: string]: Condition;
}

export interface TimeParam {
    name: string | null | undefined;
    type: string;
    filter: any;
    actions_override: any;
    supported_actions: string[];
}

interface TimeParams {
    [key: string]: TimeParam;
}

export interface RuleMetadata {
    categories: Categories;
    triggers: Triggers;
    conditions: Conditions;
    actions: Actions;
    time_params: TimeParams;
}

export enum TRIGGER_TYPE {
    PERIODIC = 'periodic',
}

export enum TRIGGER_ACTION {
    CREATE_LOGIC_CLIP = 'CREATE_LOGIC_CLIP',
    CREATE_MATERIALIZE_LOGIC_CLIP = 'CREATE_MATERIALIZE_LOGIC_CLIP',
    CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP = 'CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP',
    NOOP = 'NOOP'
}

export const ruleMetadata: any = {
    //back
    "categories": {
        "time": [
            "periodic",
            "scheduled"
        ],
        "match": [
            "on_event_analyzed",
            "on_first_half_start",
            "on_first_half_end",
            "on_second_half_start",
            "on_second_half_end",
            "on_goal"
        ],
        "calendar": [
            "on_event_analyzed",
            "on_matchday_analyzed"
        ],
        "platform": [
            "on_logic_clip_created",
            "on_materialization_created"
        ]
    },
    //back
    "triggers": {
        "periodic": {
            "actions": [
                "NOOP"
            ],
            "conditions": []
        },
        "scheduled": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP",
            ],
            "conditions": []
        },
        "on_event_analyzed": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
            ]
        },
        "on_matchday_analyzed": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
            ]
        },
        "on_logic_clip_created": {
            "actions": [],
            "conditions": []
        },
        "on_materialization_created": {
            "actions": [],
            "conditions": []
        },
        "on_first_half_start": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
            ]
        },
        "on_first_half_end": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
            ]
        },
        "on_second_half_start": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
            ]
        },
        "on_second_half_end": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
            ]
        },
        "on_goal": {
            "actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ],
            "conditions": [
                "competitions",
                "matchdays",
                "events",
                "teams",
                "periods"
            ]
        }
    },
    //locale
    "activation_filters": {
        "competitions": {
            "source": "competitions",
            // backend getCompetitions
            "options": [],
            "type": "multiobject",
            'fieldType': 'search_multistring'
        },
        //locale è un semplice int
        "matchdays": {
            "source": "matchdays",
            "options": [],
            "type": "multistring"
        },
        // Non è importante, autogestito
        "events": {
            "source": "events",
            "options": [],
            "type": "multistring",
            'fieldType': 'events'
        },
        // già fatto
        "teams": {
            "source": "teams",
            "options": [],
            "type": "multistring",
            'fieldType': 'teams'
        },
        // locale
        "key_moment_types": {
            "source": "local",
            //usa listOptions
            "options": [
            ],
            "type": "multistring",
            "fieldType": 'search_multistring'
        },
        // locale
        "periods": {
            "source": "local",
            // Getoptions di periods listoptions
            "options": [
            ],
            "type": "multistring",
            'fieldType': 'search_multistring'
        },
    },
    // locale perchè da qui ho i parametri però bisogna vedere con catello dove li prendo e dove sono
    "actions": {
        "NOOP": {
            "params": []
        },
        "CREATE_LOGIC_CLIP": {
            "params": [
                "highlight_type",
                "suggest",
                "create"
            ]
        },
        "CREATE_MATERIALIZE_LOGIC_CLIP": {
            "params": [
                "highlight_type",
                "suggest",
                "create"
            ]
        },
        "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP": {
            "params": [
                "highlight_type",
                "suggest",
                "create",
                "publish",
                "publish_delay"
            ]
        },
        "MATERIALIZE_LOGIC_CLIP": {
            "params": []
        }
    },
    // locale
    "time_params": {
        "periodic": {
            "start": {
                "type": "datetime"
            },
            "period": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 15
                }
            },
            "supported_actions": [
                "NOOP"
            ]
        },
        "scheduled": {
            "start": {
                "type": "datetime"
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP",
            ]
        },
        "on_event_analyzed": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        },
        "on_matchday_analyzed": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        },
        "on_logic_clip_created": {},
        "on_materialization_created": {},
        "on_first_half_start": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        },
        "on_first_half_end": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        },
        "on_second_half_start": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        },
        "on_second_half_end": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        },
        "on_goal": {
            "delay": {
                "type": "int",
                "filter": {
                    "op": "ge",
                    "value": 300
                }
            },
            "supported_actions": [
                "CREATE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_LOGIC_CLIP",
                "CREATE_MATERIALIZE_PUBLISH_LOGIC_CLIP"
            ]
        }
    }
}
